  <template >
   <div class="formPosition">
     <template>
  <v-container class="grey lighten-5">
    <v-row >
      <v-col md="4">
        </v-col>
         <v-col md="4">
         <h3> <span> Súmario selecionado</span></h3>
        </v-col>
        </v-row >
    <v-row no-gutters>
      <v-col >

                  <div class="flex-grow-1"></div>

<div class="text-center">

 <v-container fluid>
  </v-container>
    </div>
      </v-col>
    </v-row>
 <v-row>
         <v-col md="2" sm="1">
              <v-btn
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>picture_as_pdf</v-icon>
        </v-btn>
      </v-col>
    </v-row>
     <v-card
    class="mx-auto">
<v-row>
  <v-col md="12">
    <v-row>
     <v-col md="4" sm="1">
          <v-chip color="pink" style="margin:4px;color:white">Disciplina: {{(this.$store.state.objDisciplina.disciplina)}}</v-chip>
     </v-col>
     <v-col md="3" sm="1">
          <v-chip  style="margin:4px;">Unidade: {{(this.$store.state.objaula.unidade)}}</v-chip>
     </v-col>
     <v-col md="3" sm="1">
          <v-chip color="pink" style="margin:4px;color:white">Súmario: {{ this.$store.state.objaula.sumario  }}</v-chip>
     </v-col>
     <v-col md="2" sm="1">
          <v-chip style="margin:4px; ">Aula: {{(this.$store.state.objaula.aula)}}<strong></strong></v-chip>
     </v-col>
    </v-row>
        <v-container>
        <v-row>
        <v-col cols=12 >

    <div id="app">
        <ckeditor  :editor="editor" v-model="this.$store.state.objaula.conteudo" :config="editorConfig" :disabled="true"></ckeditor>
    </div>
     </v-col>
    </v-row>
    </v-container>

    <hr>
  </v-col>

</v-row>
  </v-card>

  </v-container>
</template>
   </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties'
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties'
import Font from '@ckeditor/ckeditor5-font/src/font'
export default {
  name: 'app',
  data: () => ({
    editor: ClassicEditor,
    editorData: '<div style="height:499px">Content of the editor.</div>',
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        ParagraphPlugin,
        Alignment,
        Table,
        TableToolbar,
        TableProperties,
        TableCellProperties,
        Font
      ],

      toolbar: {
        items: [
          'bold',
          'italic',
          'link',
          'undo',
          'redo',
          'alignment',
          'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells',
          'tableProperties', 'tableCellProperties',
          'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor'
        ]
      }
    }

  }),

  created () {
  },
  methods: {
  }
}
</script>
<style >
.editor-box> * {
    border-color: grey;
    border-style: solid;
    border-width: 1px;
}

.is-active{
    border-color: grey;
    border-style: solid;
    border-width: 1px;
}
 /* *:focus {
    outline: none;
}  */
</style>
